import { css as e } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as r, PropertyStyleSheetBehavior as p } from "@matrix42/fast-foundation";
import { designTokens as t } from "../design-tokens.js";
import { typography as l } from "../styles/typography.js";
function i(o, a) {
  return new p("size", o, a);
}
const s = (o) => e`
  .control {
    /* Layout */
    gap: ${t.spacing[8]};
  }

  ${o.prefix}-input {
    /* Base */
    width: ${t.spacing[8]};
  }

  ${o.prefix}-input::part(root) {
    /* Layout */
    width: ${t.spacing[8]};
    padding: calc(0.188 * ${t.spacing[4]}) ${t.spacing["1.5"]};
    min-height: ${t.spacing[8]};
  }

  .of,
  .total {
    /* Base */
    width: ${t.spacing[8]};
    padding: calc(0.563 * ${t.spacing[4]});
`, c = (o) => e`
  .control {
    /* Layout */
    gap: ${t.spacing[10]};
  }

  ${o.prefix}-input {
    /* Base */
    width: ${t.spacing[10]};
  }

  ${o.prefix}-input::part(root) {
    /* Layout */
    padding: calc(0.438 * ${t.spacing[4]})
      ${t.spacing["2.5"]};
  }
`, u = (o) => e`
    ${n}
    ${r("inline-flex")}
    .control {
      /* Layout */
      display: flex;
      align-items: flex-start;
    }

    .of,
    .total {
      /* Base */
      width: ${t.spacing[10]};
      /* Layout */
      display: flex;
      padding: ${t.spacing["2.5"]};
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .pages {
      /* Base */
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .of,
    .total {
      /* Style */
      text-align: center;
      /* Typography */
      ${l("p", "regular", !0)}
    }

    .of {
      /* Style */
      color: ${t.color.neutral[300]};
    }

    .total {
      /* Style */
      color: ${t.color.neutral[500]};
      /* Typography */
      font-weight: ${t.fontWeight.semibold};
    }

    ${o.prefix}-icon.validation-icon {
      /* Base */
      display: none;
    }

    ${o.prefix}-input::part(control) {
      /* Style */
      text-align: center;
      color: ${t.color.primary[100]};
      /* Typography */
      font-weight: ${t.fontWeight.semibold};
    }

    ${o.prefix}-input[disabled]::part(control) {
      /* Style */
      color: ${t.color.neutral[100]};
    }

    ${o.prefix}-listbox::part(selected-value) {
      /* Style */
      color: ${t.color.neutral[400]};
      /* Typography */
      font-weight: ${t.fontWeight.semibold};
    }
  `.withBehaviors(
  i("sm", s(o)),
  i("md", c(o))
);
export {
  u as paginationStyles
};
